module.exports = {
  Axis: require('./axis/'),
  Component: require('./base'),
  Guide: require('./guide/'),
  Label: require('./label/'),
  Legend: require('./legend/'),
  Tooltip: require('./tooltip/')
};


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 126
// module chunks = 0